<template>
  <ModalConfirmAction
    title="Excluir cronômetro"
    message="Tem certeza que deseja remover o cronômetro?"
    confirmText="Excluir"
    :loading="loading"
    @confirm="removerCronometro(cronometro.id)"
  >
    <template #activator="{ on, attrs }">
      <v-tooltip left color="surface_neutral_selected">
        <template v-slot:activator="{ on: tooltipOn, attrs: tooltipAttrs }">
          <div class="card-action-box card-action-box--delete" v-bind="{ ...attrs, ...tooltipAttrs }" v-on="{ ...on, ...tooltipOn }" role="button" aria-label="Excluir">
        <v-icon>mdi-delete-outline</v-icon>
      </div>
        </template>
        <span>Excluir</span>
      </v-tooltip>
    </template>
  </ModalConfirmAction>
</template>

<script>
import { apiClient } from "@/services/api";
import { mapActions, mapGetters } from "vuex";
import ModalConfirmAction from "../ModalConfirmAction.vue";

export default {
  components: { ModalConfirmAction },
  props: {
    cronometro: Object,
  },
  data() {
    return {
      loading: false,
    };
  },
  computed: {
    ...mapGetters({
      cod_pasta: "pastas/getterCodPasta",
    }),
  },
  methods: {
    ...mapActions({
      getCronometrosProducao: "cronometros/getCronometrosByProducao",
    }),
    async removerCronometro(id) {
      try {
        this.loading = true;

        const response = await apiClient.delete(`/cronometro/${id}`);

        if (response.status === 200) {
          await this.getCronometrosProducao({
            cod_producao: this.$store.state.producoes.selectedProducao.cod_producao,
            flg_favorita: this.$store.state.cronometros.flg_favorita,
            filtro_texto: this.$store.state.cronometros.filtroCronometros,
            cod_pasta: this.cod_pasta,
            size: this.size,
            page: this.$store.state.cronometros.cronometrosProducao.currentPage,
          });
          this.$toast.success("Cronômetro removido com sucesso");
          return;
        }
      } catch (error) {
        console.error(error);
        this.$toast.error("Não foi possível excluir o cronômetro.");
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.deleteButton1 {
  background: var(--v-surface_neutral_selected-base) !important;
}
</style>
